<template>
  <div class="cf-plan-check-container">
    <!-- ====== 顶部：筛选区域 ====== -->
    <div class="filter-section">
      <el-form :inline="true" size="small" class="filter-form" :model="filterForm">
        <el-form-item label="房屋地址">
          <el-input
            v-model="filterForm.房屋地址"
            placeholder="请输入房屋地址"
            clearable
            style="width:200px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>

        <el-form-item label="状态">
          <el-select
            v-model="filterForm.状态"
            placeholder="请选择状态"
            clearable
            style="width:140px"
            @change="handleSearch"
          >
            <el-option label="待审核" value="待审核" />
            <el-option label="已通过" value="已通过" />
            <el-option label="退回" value="退回" />
          </el-select>
        </el-form-item>

        <el-form-item label="出房人">
          <el-input
            v-model="filterForm.出房人"
            placeholder="请输入出房人"
            clearable
            style="width:150px"
            @keyup.enter.native="handleSearch"
          />
        </el-form-item>

        <el-form-item label="预计付款时间">
          <el-date-picker
            v-model="filterForm.预计付款时间范围"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            style="width:240px"
            @change="handleSearch"
          />
        </el-form-item>

        <el-form-item label="收款时间">
          <el-date-picker
            v-model="filterForm.收款时间范围"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            style="width:240px"
            @change="handleSearch"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- ====== 中间：按钮区域 ====== -->
   <div class="button-section">
  <el-button
    type="info"
    size="medium"
    icon="el-icon-view"
    :disabled="!canOperate"
    @click="openDetailDialog"
  >
    详情
  </el-button>
  <el-button
    type="primary"
    size="medium"
    icon="el-icon-check"
    :disabled="!canOperate || (selectedRows.length === 1 && selectedRows[0].状态 !== '待审核')"
    @click="openAuditDialog"
  >
    审核
  </el-button>
  <el-button
    type="danger"
    size="medium"
    icon="el-icon-delete"
    :disabled="!canOperate"
    @click="handleDelete"
  >
    删除
  </el-button>
  <el-button
    type="warning"
    size="medium"
    icon="el-icon-refresh-left"
    :disabled="!canOperate || (selectedRows.length === 1 && selectedRows[0].状态 === '待审核')"
    @click="handleWithdraw"
  >
    撤回审核
  </el-button>
  <el-button
    type="success"
    size="medium"
    icon="el-icon-house"
    :disabled="!canOperate"
    @click="openHouseDetailDialog"
  >
    查看出房信息
  </el-button>
</div>

    <!-- ====== 下方：表格区域 ====== -->
    <div class="table-section">
      <el-table
        ref="tableRef"
        :data="tableData"
        border
        stripe
        highlight-current-row
        v-loading="loading"
        @selection-change="handleSelectionChange"
        @row-click="handleRowClick"
         @row-dblclick="handleRowDblclick"  
        style="width: 100%"
        max-height="550"
      >
        <el-table-column type="selection" width="50" align="center" />
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="状态" label="状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="getStatusType(row.状态)" size="small">
              {{ row.状态 || '-' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="租客姓名" label="租客姓名" width="100" align="center" />
        <el-table-column prop="房屋地址" label="房屋地址" min-width="160" align="center" show-overflow-tooltip />
        <el-table-column prop="合同起始日" label="合同起始日" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.合同起始日) }}
          </template>
        </el-table-column>
        <el-table-column prop="合同到期日" label="合同到期日" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.合同到期日) }}
          </template>
        </el-table-column>
        <el-table-column prop="付款时间" label="预计付款时间" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.付款时间) }}
          </template>
        </el-table-column>
        <el-table-column prop="付款金额" label="预计付款金额" width="130" align="center">
          <template slot-scope="{ row }">
            {{ row.付款金额 ? `¥${row.付款金额}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="实际收款时间" label="收款时间" width="120" align="center">
          <template slot-scope="{ row }">
            {{ formatTimestamp(row.实际收款时间) }}
          </template>
        </el-table-column>
        <el-table-column prop="实际收款金额" label="收款金额" width="130" align="center">
          <template slot-scope="{ row }">
            {{ row.实际收款金额 ? `¥${row.实际收款金额}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="租金" label="租金" width="120" align="center">
          <template slot-scope="{ row }">
            {{ row.租金 ? `¥${row.租金}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="水电费" label="水电费" width="120" align="center">
          <template slot-scope="{ row }">
            {{ row.水电费 ? `¥${row.水电费}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="宽带费" label="物业宽带费" width="130" align="center">
          <template slot-scope="{ row }">
            {{ row.宽带费 ? `¥${row.宽带费}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="押金总额" label="押金总额" width="120" align="center">
          <template slot-scope="{ row }">
            {{ row.押金总额 ? `¥${row.押金总额}` : '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="第几次付款" label="第几次付款" width="110" align="center" />
        <el-table-column prop="出房人" label="出房人" width="100" align="center" />
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageInfo.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          background
        />
      </div>
    </div>

    <!-- ====== 详情弹窗 ====== -->
    <el-dialog
      title="付款明细详情"
      :visible.sync="detailDialog.visible"
      width="700px"
      :close-on-click-modal="false"
      class="detail-dialog"
      top="10vh"
    >
      <el-descriptions :column="2" border size="medium" v-loading="detailDialog.loading">
        <el-descriptions-item label="房屋地址" :span="2">
          {{ detailDialog.data.房屋地址 || '-' }}
        </el-descriptions-item>

        <el-descriptions-item label="预计收款时间">
          {{ formatTimestamp(detailDialog.data.付款时间) }}
        </el-descriptions-item>
        <el-descriptions-item label="预计收款金额">
          {{ detailDialog.data.付款金额 ? `¥${detailDialog.data.付款金额}` : '-' }}
        </el-descriptions-item>

        <el-descriptions-item label="实际收款时间">
          {{ formatTimestamp(detailDialog.data.实际收款时间) }}
        </el-descriptions-item>
        <el-descriptions-item label="实际收款金额">
          {{ detailDialog.data.实际收款金额 ? `¥${detailDialog.data.实际收款金额}` : '-' }}
        </el-descriptions-item>

        <el-descriptions-item label="租金">
          {{ detailDialog.data.租金 ? `¥${detailDialog.data.租金}` : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="水电费">
          {{ detailDialog.data.水电费 ? `¥${detailDialog.data.水电费}` : '-' }}
        </el-descriptions-item>

        <el-descriptions-item label="宽带费">
          {{ detailDialog.data.宽带费 ? `¥${detailDialog.data.宽带费}` : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="押金总额">
          {{ detailDialog.data.押金总额 ? `¥${detailDialog.data.押金总额}` : '-' }}
        </el-descriptions-item>

        <el-descriptions-item label="状态">
          <el-tag :type="getStatusType(detailDialog.data.状态)" size="small">
            {{ detailDialog.data.状态 || '-' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="备注">
          {{ detailDialog.data.备注 || '-' }}
        </el-descriptions-item>
      </el-descriptions>

      <!-- 附件表格 -->
      <div class="file-group">
        <div class="file-group-header">
          <span class="file-group-title">付款凭证</span>
        </div>
        <el-table :data="detailDialog.fileList" border stripe size="small" v-loading="detailDialog.fileLoading">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
          <el-table-column label="预览" width="150" align="center">
            <template slot-scope="{ row }">
              <div v-if="isImage(row.suffix) && (row.show_path_full || row.show_path)" class="preview-thumbnail">
                <el-image
                  :src="row.show_path_full || row.show_path"
                  fit="cover"
                  style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                  :preview-src-list="[row.show_path_full || row.show_path]"
                />
              </div>
              <span v-else class="preview-placeholder">仅支持图片预览</span>
            </template>
          </el-table-column>
          <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" size="mini" @click="handleViewFile(row)">查看</el-button>
              <el-button type="text" size="mini" @click="handleDownloadFile(row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="detailDialog.fileList.length === 0" class="empty-tip">
          暂无付款凭证
        </div>
      </div>

      <span slot="footer">
        <el-button @click="detailDialog.visible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- ====== 审核弹窗 ====== -->
    <el-dialog
      title="审核付款明细"
      :visible.sync="auditDialog.visible"
      width="700px"
      :close-on-click-modal="false"
      class="audit-dialog"
      top="10vh"
    >
      <el-descriptions :column="2" border size="medium">
        <el-descriptions-item label="房屋地址" :span="2">
          {{ auditDialog.data.房屋地址 || '-' }}
        </el-descriptions-item>

        <el-descriptions-item label="预计收款时间">
          {{ formatTimestamp(auditDialog.data.付款时间) }}
        </el-descriptions-item>
        <el-descriptions-item label="预计收款金额">
          {{ auditDialog.data.付款金额 ? `¥${auditDialog.data.付款金额}` : '-' }}
        </el-descriptions-item>

        <el-descriptions-item label="实际收款时间">
          {{ formatTimestamp(auditDialog.data.实际收款时间) }}
        </el-descriptions-item>
        <el-descriptions-item label="实际收款金额">
          {{ auditDialog.data.实际收款金额 ? `¥${auditDialog.data.实际收款金额}` : '-' }}
        </el-descriptions-item>

        <el-descriptions-item label="租金">
          {{ auditDialog.data.租金 ? `¥${auditDialog.data.租金}` : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="水电费">
          {{ auditDialog.data.水电费 ? `¥${auditDialog.data.水电费}` : '-' }}
        </el-descriptions-item>

        <el-descriptions-item label="宽带费">
          {{ auditDialog.data.宽带费 ? `¥${auditDialog.data.宽带费}` : '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="押金总额">
          {{ auditDialog.data.押金总额 ? `¥${auditDialog.data.押金总额}` : '-' }}
        </el-descriptions-item>

        <el-descriptions-item label="状态" :span="2">
          <el-tag :type="getStatusType(auditDialog.data.状态)" size="small">
            {{ auditDialog.data.状态 || '-' }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="备注" :span="2">
          {{ auditDialog.data.备注 || '-' }}
        </el-descriptions-item>
      </el-descriptions>

      <!-- 附件表格 -->
      <div class="file-group">
        <div class="file-group-header">
          <span class="file-group-title">付款凭证</span>
        </div>
        <el-table :data="auditDialog.fileList" border stripe size="small" v-loading="auditDialog.fileLoading">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="show_name" label="文件名称" min-width="200" show-overflow-tooltip />
          <el-table-column label="预览" width="150" align="center">
            <template slot-scope="{ row }">
              <div v-if="isImage(row.suffix) && (row.show_path_full || row.show_path)" class="preview-thumbnail">
                <el-image
                  :src="row.show_path_full || row.show_path"
                  fit="cover"
                  style="width: 80px; height: 60px; border-radius: 4px; cursor: pointer;"
                  :preview-src-list="[row.show_path_full || row.show_path]"
                />
              </div>
              <span v-else class="preview-placeholder">仅支持图片预览</span>
            </template>
          </el-table-column>
          <el-table-column prop="upload_time_clean" label="上传时间" width="170" align="center" />
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="{ row }">
              <el-button type="text" size="mini" @click="handleViewFile(row)">查看</el-button>
              <el-button type="text" size="mini" @click="handleDownloadFile(row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="auditDialog.fileList.length === 0" class="empty-tip">
          暂无付款凭证
        </div>
      </div>

      <span slot="footer">
        <el-button @click="auditDialog.visible = false">取消</el-button>
        <el-button
          type="success"
          @click="handleAuditPass"
          :loading="auditDialog.submitting"
        >
          通过
        </el-button>
        <el-button
          type="danger"
          @click="handleAuditReject"
          :loading="auditDialog.submitting"
        >
          退回
        </el-button>
      </span>
    </el-dialog>

    <!-- ====== 出房详情弹窗 ====== -->
    <el-dialog
      title="出房详情"
      :visible.sync="houseDialog.visible"
      width="900px"
      :close-on-click-modal="false"
      class="house-dialog"
      top="5vh"
    >
      <div v-loading="houseDialog.loading">
        <el-descriptions :column="2" border size="medium">
          <el-descriptions-item label="房屋地址" :span="2">
            {{ houseDialog.data.房屋地址 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="租客姓名">
            {{ houseDialog.data.租客姓名 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="联系电话">
            {{ houseDialog.data.联系电话 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="出房人">
            {{ houseDialog.data.出房人 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="出房门店">
            {{ houseDialog.data.出房门店 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="合同编号">
            {{ houseDialog.data.合同编号 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="开户行">
            {{ houseDialog.data.开户行 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="银行卡号">
            {{ houseDialog.data.银行卡号 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="出房渠道">
            {{ houseDialog.data.出房渠道 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="出房费用（元）">
            {{ houseDialog.data['出房费用（元）'] ? `¥${houseDialog.data['出房费用（元）']}` : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="出房押金（元）">
            {{ houseDialog.data['出房押金（元）'] ? `¥${houseDialog.data['出房押金（元）']}` : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="合同起始日" :span="2">
            {{ formatTimestamp(houseDialog.data.合同起始日) }}
          </el-descriptions-item>
          <el-descriptions-item label="合同到期日" :span="2">
            {{ formatTimestamp(houseDialog.data.合同到期日) }}
          </el-descriptions-item>
          <el-descriptions-item label="出房租金（元/月）" :span="2">
            {{ houseDialog.data['出房租金（元/月）'] ? `¥${houseDialog.data['出房租金（元/月）']}` : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="租金支付周期">
            {{ houseDialog.data.租金支付周期 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="定金金额">
            {{ houseDialog.data.定金金额 ? `¥${houseDialog.data.定金金额}` : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="物业/宽带费">
            {{ houseDialog.data.物业费 ? `¥${houseDialog.data.物业费}` : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="支付周期">
            {{ houseDialog.data['物业/宽带费支付周期'] || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="水电气押金">
            {{ houseDialog.data.水电气押金 ? `¥${houseDialog.data.水电气押金}` : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="宠物押金">
            {{ houseDialog.data.宠物押金 ? `¥${houseDialog.data.宠物押金}` : '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="特别约定" :span="2">
            {{ houseDialog.data.特别约定 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="是否更换出房人">
            {{ houseDialog.data.是否更换出房人 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="是否更换收房人">
            {{ houseDialog.data.是否更换收房人 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="紧急联系人号码">
            {{ houseDialog.data.紧急联系人号码 || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="计算空置天数">
            {{ houseDialog.data.计算空置天数 || '-' }}
          </el-descriptions-item>
        </el-descriptions>
      </div>

      <span slot="footer">
        <el-button @click="houseDialog.visible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { cfPlanApi } from '@/api/付款/cfPlanApi'
import { fileMethod } from '@/api/files/fileMethod'
import { sqlBaseApi } from '@/api/通用/sqlBaseApi'

export default {
  name: 'CfPlanCheck',

  data() {
    return {
      // ====== 筛选表单 ======
      filterForm: {
        房屋地址: '',
        状态: '待审核',
        出房人: '',
        预计付款时间范围: [],
        收款时间范围: []
      },

      // ====== 表格数据 ======
      tableData: [],
      loading: false,
      selectedRows: [],

      // ====== 分页 ======
      pageInfo: {
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },

      // ====== 详情弹窗 ======
      detailDialog: {
        visible: false,
        loading: false,
        fileLoading: false,
        data: {},
        fileList: []
      },

      // ====== 审核弹窗 ======
      auditDialog: {
        visible: false,
        submitting: false,
        fileLoading: false,
        data: {},
        fileList: []
      },

      // ====== 出房详情弹窗 ======
      houseDialog: {
        visible: false,
        loading: false,
        data: {}
      }
    }
  },

  computed: {
    canOperate() {
      return this.selectedRows.length === 1
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    // ====== 初始化 ======
    init() {
      this.loadData()
    },

    // ====== 后端字段 -> 前端字段映射 ======
    mapFields(data) {
      if (!data) return {}

      const fieldMap = {
        'id': 'id',
        '付款ID': '付款ID',
        '出房ID': '出房ID',
        '状态': '状态',
        '付款时间': '付款时间',
        '付款金额': '付款金额',
        '房屋地址': '房屋地址',
        '第几次付款': '第几次付款',
        '租客姓名': '租客姓名',
        '出房人': '出房人',
        '实际收款时间': '实际收款时间',
        '实际收款金额': '实际收款金额',
        '租金': '租金',
        '水电费': '水电费',
        '宽带费': '宽带费',
        '押金总额': '押金总额',
        '备注': '备注',
        '合同起始日': '合同起始日',
        '合同到期日': '合同到期日',
        '已收': '已收'
      }

      const result = {}
      for (const [backendKey, frontendKey] of Object.entries(fieldMap)) {
        if (data[backendKey] !== undefined && data[backendKey] !== null) {
          result[frontendKey] = data[backendKey]
        }
      }

      // 时间戳转为毫秒级
      const timestampFields = ['付款时间', '实际收款时间', '合同起始日', '合同到期日']
      timestampFields.forEach(field => {
        if (result[field] !== undefined && result[field] !== null && result[field] !== '') {
          const str = String(result[field])
          if (str.length === 10) {
            result[field] = result[field] * 1000
          }
        }
      })

      return result
    },

    // ====== 加载数据 ======
    loadData() {
      this.loading = true

      const params = {
        pageIndex: this.pageInfo.pageIndex - 1,
        pageSize: this.pageInfo.pageSize
      }

      if (this.filterForm.房屋地址) {
        params.房屋地址 = this.filterForm.房屋地址
      }
      if (this.filterForm.状态) {
        params.状态 = this.filterForm.状态
      }
      if (this.filterForm.出房人) {
        params.出房人 = this.filterForm.出房人
      }
      if (this.filterForm.预计付款时间范围 && this.filterForm.预计付款时间范围.length === 2) {
        const [start, end] = this.filterForm.预计付款时间范围
        params.付款时间_start = Math.floor(start / 1000)
        params.付款时间_end = Math.floor(end / 1000)
      }
      if (this.filterForm.收款时间范围 && this.filterForm.收款时间范围.length === 2) {
        const [start, end] = this.filterForm.收款时间范围
        params.实际收款时间_start = Math.floor(start / 1000)
        params.实际收款时间_end = Math.floor(end / 1000)
      }

      console.log('查询出房付款明细参数===', params)

      cfPlanApi.selectDetail(params).then((res) => {
        console.log('返回数据===', res)

        if (res.code === 200) {
          const rawList = res.data?.list || []
          this.tableData = rawList.map(item => this.mapFields(item))
          if (res.data?.pageIndex !== undefined) {
            this.pageInfo.pageIndex = res.data.pageIndex + 1
          }
          if (res.data?.total !== undefined) {
            this.pageInfo.total = res.data.total
          }
        } else {
          this.$message.error(res.message || '查询失败')
        }
      }).catch((err) => {
        console.error('请求失败===', err)
        this.$message.error('加载数据失败')
      }).finally(() => {
        this.loading = false
      })
    },

    // ====== 搜索 ======
    handleSearch() {
      this.pageInfo.pageIndex = 1
      this.loadData()
    },

    // ====== 重置搜索 ======
    resetSearch() {
      this.filterForm = {
        房屋地址: '',
        状态: '待审核',
        出房人: '',
        预计付款时间范围: [],
        收款时间范围: []
      }
      this.handleSearch()
    },

    // ====== 分页 ======
    handleSizeChange(size) {
      this.pageInfo.pageSize = size
      this.pageInfo.pageIndex = 1
      this.loadData()
    },

    handleCurrentChange(page) {
      this.pageInfo.pageIndex = page
      this.loadData()
    },

    // ====== 表格选择变化 ======
    handleSelectionChange(selection) {
      this.selectedRows = selection
    },

    // ====== 行点击 ======
    handleRowClick(row) {
      this.$refs.tableRef.toggleRowSelection(row)
    },
    // ====== 双击行打开详情 ======
handleRowDblclick(row) {
  this.selectedRows = [row]
  this.openDetailDialog()
},

    // ====== 状态标签颜色 ======
    getStatusType(status) {
      const map = {
        '待审核': 'warning',
        '已通过': 'success',
        '退回': 'danger'
      }
      return map[status] || 'info'
    },

    // ====== 时间戳格式化 ======
    formatTimestamp(timestamp) {
      if (!timestamp) return '-'
      let ts = timestamp
      const str = String(ts)
      if (str.length === 10) {
        ts = ts * 1000
      }
      const date = new Date(ts)
      if (isNaN(date.getTime())) {
        return '-'
      }
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // ====== 判断是否为图片 ======
    isImage(suffix) {
      if (!suffix) return false
      const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      return imageTypes.includes(suffix.toLowerCase())
    },

    // ====== 查看文件 ======
    handleViewFile(row) {
      const url = row.show_path_full || row.show_path
      if (url) {
        window.open(url, '_blank')
      } else {
        this.$message.warning('文件路径不存在')
      }
    },

    // ====== 下载文件 ======
    async handleDownloadFile(row) {
      if (!row.show_path) {
        this.$message.warning('文件路径不存在')
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '正在下载文件...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        const res = await fileMethod.downloadFile(row.show_path)
        const blob = new Blob([res.data])
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = row.show_name || '下载文件'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.$message.success('下载成功')
      } catch (error) {
        console.error('下载失败:', error)
        this.$message.error('下载失败，请重试')
      } finally {
        loading.close()
      }
    },

    // ============================================================
    // 加载附件
    // ============================================================
    async loadFileList(fatherId) {
      if (!fatherId) return []

      const fileBaseUrl = window.applicationConfig?.fileBaseUrl || window.location.origin + '/nngy/'

      try {
        const res = await fileMethod.listFiles('出房付款明细', String(fatherId), '出房付款明细凭证', null)
        if (res.code === 200) {
          const list = res.data?.list || []
          return list.map(item => {
            if (item.show_path) {
              const isFullUrl = item.show_path.startsWith('http://') || item.show_path.startsWith('https://')
              item.show_path_full = isFullUrl ? item.show_path : fileBaseUrl + item.show_path.replace(/^\//, '')
            }
            return item
          })
        }
        return []
      } catch (error) {
        console.error('加载附件失败:', error)
        return []
      }
    },

    // ============================================================
    // 详情弹窗
    // ============================================================
    async openDetailDialog() {
      if (this.selectedRows.length !== 1) {
        this.$message.warning('请选择一条记录')
        return
      }

      const row = this.selectedRows[0]
      this.detailDialog.data = { ...row }
      this.detailDialog.visible = true
      this.detailDialog.loading = false
      this.detailDialog.fileList = []
      this.detailDialog.fileLoading = true

      const files = await this.loadFileList(row.id)
      this.detailDialog.fileList = files
      this.detailDialog.fileLoading = false
    },

    // ============================================================
    // 审核弹窗
    // ============================================================
    async openAuditDialog() {
      if (this.selectedRows.length !== 1) {
        this.$message.warning('请选择一条记录')
        return
      }

      const row = this.selectedRows[0]
      if (row.状态 !== '待审核') {
        this.$message.warning('只有"待审核"的记录可以审核')
        return
      }

      this.auditDialog.data = { ...row }
      this.auditDialog.visible = true
      this.auditDialog.fileList = []
      this.auditDialog.fileLoading = true

      const files = await this.loadFileList(row.id)
      this.auditDialog.fileList = files
      this.auditDialog.fileLoading = false
    },

    // ====== 审核通过 ======
    async handleAuditPass() {
      const row = this.auditDialog.data

      try {
        await this.$confirm(
          `确认通过该付款记录吗？`,
          '审核通过确认',
          {
            type: 'warning',
            confirmButtonText: '确认通过',
            cancelButtonText: '取消'
          }
        )
      } catch {
        return
      }

      this.auditDialog.submitting = true

      try {
        // 1. 更新明细状态为"已通过"
        const updateRes = await cfPlanApi.updateDetail({
          id: row.id,
          状态: '已通过'
        })
        console.log('审核通过-更新明细返回:', updateRes)

        if (updateRes.code !== 200) {
          this.$message.error(updateRes.message || '审核通过失败')
          this.auditDialog.submitting = false
          return
        }

        // 2. 更新出房付款计划汇总
        if (row.付款ID) {
          const planRes = await cfPlanApi.updatePlanByDetails({
            id: String(row.付款ID)
          })
          console.log('审核通过-更新计划返回:', planRes)
          if (planRes.code !== 200) {
            this.$message.warning('明细已通过，但计划汇总更新失败，请手动刷新')
          }
        }

        this.$message.success('审核通过成功！')
        this.auditDialog.visible = false
        this.loadData()

      } catch (error) {
        console.error('审核通过失败:', error)
        this.$message.error(error.message || '审核通过失败，请稍后重试')
      } finally {
        this.auditDialog.submitting = false
      }
    },

    // ====== 审核退回 ======
    async handleAuditReject() {
      const row = this.auditDialog.data

      try {
        await this.$confirm(
          `确认退回该付款记录吗？`,
          '审核退回确认',
          {
            type: 'warning',
            confirmButtonText: '确认退回',
            cancelButtonText: '取消'
          }
        )
      } catch {
        return
      }

      this.auditDialog.submitting = true

      try {
        const updateRes = await cfPlanApi.updateDetail({
          id: row.id,
          状态: '退回'
        })
        console.log('审核退回-更新明细返回:', updateRes)

        if (updateRes.code !== 200) {
          this.$message.error(updateRes.message || '审核退回失败')
          this.auditDialog.submitting = false
          return
        }

        this.$message.success('审核退回成功！')
        this.auditDialog.visible = false
        this.loadData()

      } catch (error) {
        console.error('审核退回失败:', error)
        this.$message.error(error.message || '审核退回失败，请稍后重试')
      } finally {
        this.auditDialog.submitting = false
      }
    },

    // ============================================================
    // 删除
    // ============================================================
    async handleDelete() {
      if (this.selectedRows.length !== 1) {
        this.$message.warning('请选择一条记录')
        return
      }

      const row = this.selectedRows[0]

      try {
        await this.$confirm(
          `确认删除该付款记录吗？删除后不可恢复！`,
          '删除确认',
          {
            type: 'warning',
            confirmButtonText: '确认删除',
            cancelButtonText: '取消'
          }
        )
      } catch {
        return
      }

      try {
        const res = await cfPlanApi.deleteDetail({ id: row.id })
        console.log('删除返回:', res)

        if (res.code === 200 && res.data?.deleted) {
          this.$message.success('删除成功！')
          this.loadData()
        } else {
          this.$message.warning(res.data?.message || '删除失败')
        }
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error(error.message || '删除失败，请稍后重试')
      }
    },

    // ============================================================
    // 撤回审核
    // ============================================================
    async handleWithdraw() {
      if (this.selectedRows.length !== 1) {
        this.$message.warning('请选择一条记录')
        return
      }

      const row = this.selectedRows[0]

      if (row.状态 === '待审核') {
        this.$message.warning('待审核的记录无需撤回')
        return
      }

      try {
        await this.$confirm(
          `此条记录目前是"${row.状态}"的状态，是否撤回？`,
          '撤回审核确认',
          {
            type: 'warning',
            confirmButtonText: '确认撤回',
            cancelButtonText: '取消'
          }
        )
      } catch {
        return
      }

      try {
        // 1. 更新明细状态为"待审核"
        const updateRes = await cfPlanApi.updateDetail({
          id: row.id,
          状态: '待审核'
        })
        console.log('撤回审核-更新明细返回:', updateRes)

        if (updateRes.code !== 200) {
          this.$message.error(updateRes.message || '撤回审核失败')
          return
        }

        // 2. 更新出房付款计划汇总
        if (row.付款ID) {
          const planRes = await cfPlanApi.updatePlanByDetails({
            id: String(row.付款ID)
          })
          console.log('撤回审核-更新计划返回:', planRes)
          if (planRes.code !== 200) {
            this.$message.warning('明细已撤回，但计划汇总更新失败，请手动刷新')
          }
        }

        this.$message.success('撤回审核成功！')
        this.loadData()

      } catch (error) {
        console.error('撤回审核失败:', error)
        this.$message.error(error.message || '撤回审核失败，请稍后重试')
      }
    },

    // ============================================================
    // 查看出房信息
    // ============================================================
    async openHouseDetailDialog() {
      if (this.selectedRows.length !== 1) {
        this.$message.warning('请选择一条记录')
        return
      }

      const row = this.selectedRows[0]

      if (!row.出房ID) {
        this.$message.warning('该记录没有关联的出房ID')
        return
      }

      this.houseDialog.visible = true
      this.houseDialog.loading = true
      this.houseDialog.data = {}

      try {
        const params = {
          tableName: '出房管理',
          conditions: [
            {
              field: 'id',
              type: 'STRING',
              operator: 'EQ',
              value: String(row.出房ID)
            }
          ],
          pageIndex: 1,
          pageSize: 1
        }

        const res = await sqlBaseApi.query(params)
        console.log('查询出房信息返回:', res)

        if (res.code === 200) {
          const list = res.data?.list || []
          if (list.length > 0) {
            this.houseDialog.data = this.mapHouseFields(list[0])
          } else {
            this.$message.warning('未找到该出房信息')
          }
        } else {
          this.$message.error(res.message || '查询出房信息失败')
        }
      } catch (error) {
        console.error('查询出房信息失败:', error)
        this.$message.error('查询出房信息失败，请重试')
      } finally {
        this.houseDialog.loading = false
      }
    },

    mapHouseFields(data) {
      if (!data) return {}

      const fieldMap = {
        '房屋地址': '房屋地址',
        '租客姓名': '租客姓名',
        '联系电话': '联系电话',
        '出房人': '出房人',
        '出房门店': '出房门店',
        '合同编号': '合同编号',
        '开户行': '开户行',
        '银行卡号': '银行卡号',
        '出房渠道': '出房渠道',
        '出房费用（元）': '出房费用（元）',
        '出房押金（元）': '出房押金（元）',
        '合同起始日': '合同起始日',
        '合同到期日': '合同到期日',
        '出房租金（元/月）': '出房租金（元/月）',
        '租金支付周期': '租金支付周期',
        '定金金额': '定金金额',
        '物业费': '物业费',
        '物业/宽带费支付周期': '物业/宽带费支付周期',
        '水电气押金': '水电气押金',
        '宠物押金': '宠物押金',
        '特别约定': '特别约定',
        '是否更换出房人': '是否更换出房人',
        '是否更换收房人': '是否更换收房人',
        '紧急联系人号码': '紧急联系人号码',
        '计算空置天数': '计算空置天数'
      }

      const result = {}
      for (const [backendKey, frontendKey] of Object.entries(fieldMap)) {
        if (data[backendKey] !== undefined && data[backendKey] !== null) {
          result[frontendKey] = data[backendKey]
        }
      }

      // 时间戳转为毫秒级
      const timestampFields = ['合同起始日', '合同到期日']
      timestampFields.forEach(field => {
        if (result[field] !== undefined && result[field] !== null && result[field] !== '') {
          const str = String(result[field])
          if (str.length === 10) {
            result[field] = result[field] * 1000
          }
        }
      })

      return result
    },

    // ====== 刷新数据 ======
    refresh() {
      this.loadData()
    }
  }
}
</script>

<style scoped>
.cf-plan-check-container {
  padding: 20px;
  background: #f0f2f5;
  min-height: 100vh;
}

.filter-section {
  background: #fff;
  padding: 20px 20px 0 20px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.filter-form {
  margin-bottom: 0;
}

.button-section {
  background: #fff;
  padding: 12px 20px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.button-section .el-button {
  margin-bottom: 4px;
}

.table-section {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}

.pagination-section {
  margin-top: 16px;
  text-align: right;
  flex-shrink: 0;
}

.detail-dialog .el-descriptions,
.audit-dialog .el-descriptions,
.house-dialog .el-descriptions {
  margin-bottom: 16px;
}

.file-group {
  margin-top: 8px;
}

.file-group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0 10px 0;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
}

.file-group-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.preview-thumbnail {
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-placeholder {
  font-size: 12px;
  color: #909399;
}

.empty-tip {
  text-align: center;
  padding: 12px 0;
  color: #909399;
  font-size: 13px;
  background: #f5f7fa;
  border-radius: 4px;
  margin-top: 4px;
}

.detail-dialog /deep/ .el-dialog__body,
.audit-dialog /deep/ .el-dialog__body {
  max-height: 70vh;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .cf-plan-check-container {
    padding: 10px;
  }

  .filter-form .el-form-item {
    display: block;
    margin-right: 0;
  }

  .button-section .el-button {
    margin-bottom: 8px;
  }
}
</style>